// @flow

import * as React from 'react'
import { connect, type Connector } from 'react-redux'
import { Button } from 'semantic-ui-react'

import FileDownloaderButton from '../systemwide/file-downloader-button'
import { addErrorNotification } from '../store/notification-manager'
import { openSystemSidebar } from '../store/app'
import { onModifyRecord, deleteVisitRequest } from '../store/manage-visits'
import { isAdmin, isEditor, getUsername } from '../store/authentication'
import type { ReduxState, Dispatch } from '../store'

type OwnProps = {||}

type MappedProps = {|
  currentCampaign: string,
  sortKey: string,
  sortDir: string,
  filter: string,
  totRecords: number,
  selectedRecords: Array<Object>,
  isAdmin: boolean,
  isEditor: boolean,
  username: string,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  return {
    currentCampaign: state.allowedCampaigns.currentCampaign,
    sortKey: state.visits.grid.sortKey,
    sortDir: state.visits.grid.sortDir,
    filter: state.visits.grid.filterTerms,
    totRecords: state.visits.grid.totRecords,
    selectedRecords: state.visits.grid.selectedRecords,
    isAdmin: isAdmin(state),
    isEditor: isEditor(state),
    username: getUsername(state),
  }
}

type Props = { dispatch: Dispatch } & OwnProps & MappedProps

class VisitsToolbar extends React.Component<Props> {
  static defaultProps = {}

  onOpenSystemSidebar = () => {
    this.props.dispatch(openSystemSidebar())
  }

  onModifyRecord = () => {
    this.props.dispatch(onModifyRecord(this.props.selectedRecords[0]))
  }

  onDeleteVisit = () => {
    this.props.dispatch(deleteVisitRequest(this.props.selectedRecords[0]))
  }

  onDownloadError = () => {
    this.props.dispatch(addErrorNotification('Errore di download'))
  }

  disableEdit = () => {
    return (
      this.props.selectedRecords.length === 0 ||
      (!this.props.isAdmin && this.props.selectedRecords[0].uploaded_by !== this.props.username)
    )
  }

  render() {
    return (
      <div style={{ float: 'left' }}>
        {(this.props.isAdmin || this.props.isEditor) && (
          <Button
            icon="upload"
            content="Carica visite"
            labelPosition="left"
            size="small"
            color="green"
            style={{ minWidth: '20ex' }}
            onClick={this.onOpenSystemSidebar}
          />
        )}
        {(this.props.isAdmin || this.props.isEditor) && (
          <Button
            style={{ minWidth: '20ex' }}
            icon="edit"
            content="Modifica"
            labelPosition="left"
            size="small"
            primary
            disabled={this.disableEdit()}
            onClick={this.onModifyRecord}
          />
        )}
        {(this.props.isAdmin || this.props.isEditor) && (
          <Button
            style={{ minWidth: '20ex', marginRight: '2ex' }}
            icon="delete"
            content="Elimina"
            labelPosition="left"
            size="small"
            color="red"
            disabled={this.disableEdit()}
            onClick={this.onDeleteVisit}
          />
        )}
        <FileDownloaderButton
          downloadUrl={'/api/visits/' + this.props.currentCampaign + '/export'}
          downloadParams={{
            filter: this.props.filter,
            sortKey: this.props.sortKey,
            sortDir: this.props.sortDir,
          }}
          label="Esporta"
          disabled={this.props.totRecords === 0}
          onError={this.onDownloadError}
        />
      </div>
    )
  }
}

const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(VisitsToolbar)



// WEBPACK FOOTER //
// ./src/visits/visits-toolbar.js